import React, { useState } from 'react';
import { Building2, ChevronUp, ChevronRight } from 'lucide-react';
import SubsitioGroup from './SubsitioGroup';

/**
 * Componente colapsable que agrupa subsitios de un sitio
 * 
 * @component
 * @param {Object} props
 * @param {string} props.sitioNombre - Nombre del sitio
 * @param {Object} props.sitioData - Datos del sitio con subsitios
 * @param {string} props.estado - Estado geográfico del sitio
 * @param {Array} props.visibleColumns - Columnas visibles
 */
const SitioGroup = ({ sitioNombre, sitioData, estado, visibleColumns }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const totalVehiculos = sitioData.totalVehiculos;

    return (
        <div className="border border-gray-300 rounded-lg overflow-hidden mb-4 shadow-sm">
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="w-full px-3 sm:px-4 py-3 bg-blue-50 hover:bg-blue-100 flex items-center justify-between gap-2 transition-colors text-left"
            >
                <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                    <Building2 className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 shrink-0" />
                    <div className="min-w-0">
                        <h4 className="font-medium text-gray-900 text-sm sm:text-base truncate">{sitioNombre}</h4>
                        <p className="text-xs sm:text-sm text-gray-600 truncate">
                            {estado} • {Object.keys(sitioData.subsitios).length} subsitio(s) • {totalVehiculos} vehículo(s)
                        </p>
                    </div>
                </div>
                <div className="shrink-0">
                    {isExpanded ? (
                        <ChevronUp className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
                    ) : (
                        <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
                    )}
                </div>
            </button>

            {isExpanded && (
                <div className="p-3 space-y-2 bg-gray-50">
                    {Object.entries(sitioData.subsitios).map(([subsitioNombre, vehiculos]) => (
                        <SubsitioGroup
                            key={subsitioNombre}
                            subsitioNombre={subsitioNombre}
                            vehiculos={vehiculos}
                            sitioNombre={sitioNombre}
                            visibleColumns={visibleColumns}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SitioGroup;